import { FONT_TITLE, FONT_TITLE_CSS, GAME_BACKGROUND_COLOR } from 'app/constants/AppConstants';
import * as WebFont from 'utils/webfontloader';

class Boot extends Phaser.State {
  preload(game) {
    this.fontsReady = false;
    this.loadComplete = false;

    // game assets
    game.load.baseURL = this.game.urls.getAssetsDirectory();

    game.load.crossOrigin = 'anonymous';
    game.load.pack('boot', 'assetpack.json', null, this);

    WebFont.load({
      custom: {
        families: [FONT_TITLE],
        urls: [this.game.urls.getFontsDirectory(FONT_TITLE_CSS)],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });

    this.game = game;

    game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
    game.scale.fullScreenScaleMode = Phaser.ScaleManager.SHOW_ALL;
    game.scale.pageAlignHorizontally = true;
    game.scale.pageAlignVertically = true;

    game.stage.disableVisibilityChange = true;
    game.scale.forceOrientation(true, false);

    this.firstRunPortrait = game.scale.isGamePortrait;

    game.add.plugin(PhaserSpine.SpinePlugin);
  }

  fontsLoaded() {
    this.fontsReady = true;
  }

  create(game) {
    this.stage.backgroundColor = GAME_BACKGROUND_COLOR;

    this.loadComplete = true;
  }

  update(game) {
    this.checkLoading(game);
  }

  checkLoading(game) {
    if (this.loadComplete && this.fontsReady) {
      game.addCopy(this.game.cache.getXML('copy_xml'));
      game.controller.startLoad();
    }
  }
}

export default Boot;
